import AdminProductCreateForm from './AdminProductCreateForm';

export default AdminProductCreateForm;
